import { Isearch } from "../../../schemas/Search/Search.schema";
import * as Constants from "../../../utils/constants";
import { getSearchInputes } from "../../../containers/SearchContainer/searchUtility";
import { ToastMessage } from "../../../utils/ToastMessage";
import { Favorite } from '../../../models/home/favorite.model';
import i18n from "../../../../i18n";
import { logEvent } from '../../../utils/Analytics';
import { EVENT, SCREEN, TAB } from '../../../utils/constants.analytics';
import { IONICWrapper } from "../../../utils/common";

export const newSearch = async (state: any, props: any, updateFav: boolean = false) => {
  const {
    origin,
    originCountry,
    originRadius,
    originPostalCode,
    pickUpStartDate,
    pickUpEndDate,
    TrailerType,
    dropStartDate,
    dropEndDate,
    destinationRadius,
    favorite,
    destination,
    destinationPostalCode,
    criteriaId,
  } = state;
  // Generate Query For request
  let pickupLocal = "";
  if (state.pickUpLocalTime) {
    pickupLocal = state.pickUpLocalTime.split("T")[1];
    const index = pickupLocal.indexOf("-");
    const timezone =
      index !== -1 ? pickupLocal.slice(index, index + 6) : "-00:00";
    pickupLocal = pickupLocal.slice(0, 12) + timezone;
  }
  let dropLocal = "";
  if (state.dropLocalTime) {
    dropLocal = state.dropLocalTime.split("T")[1];
    const index = dropLocal.indexOf("-");
    const timezone =
      index !== -1 ? dropLocal.slice(index, index + 6) : "-00:00";
    dropLocal = dropLocal.slice(0, 12) + timezone;
  }
  let originCity = null;
  let originState = null;
  let destinationCity = null;
  let destinationStates = [];
  let destinationCountry = state.destinationCountry;
  let newdropStartDate = dropStartDate;
  let newdropEndDate = dropEndDate;
  if (origin) {
    let originArray =
      getOriginArray(origin);
    originCity = originArray[0];
    originState = originArray[1].trim();
  }
  if (destination && !state.isStatesShow) {
    let destinationArray =
      getDestinationArray(destination);
    destinationCity = destinationArray[0];
    destinationCity !== Constants.Anywhere && destinationStates.push(destinationArray[1] && destinationArray[1].trim());
  }
  if (state.isStatesShow) {
    state.statesList.map((state: any) => {
      if (state.value && state.value !== "None") destinationStates.push(state.value);
    });
    destinationCity = "";
    destinationCountry = state.country;
  }
  if (
    getOrginAndDestinationCheck(state, destinationStates)
  ) {
    ToastMessage.open({
      message: "Select a City State or at least one State for the location.",
      showUndo: false,
    });
  } else if (
    state.origin === Constants.Anywhere && state.isStatesShow
  ) {
    ToastMessage.open({
      message: "Please select a Origin ",
      showUndo: false,
    });
  } else {
    let isDestinationError = false;
    isDestinationError = getDestinationError(state, isDestinationError);
    if (
      errorValidation(state, isDestinationError)
    ) {
      if (updateFav) {
        const searchParams: any = {
          originCity,
          originCountry,
          originState,
          originPostalCode,
          originradius: originRadius,
          destinationCity,
          destinationStates,
          destinationCountry,
          destinationPostalCode : state.isStatesShow ? "" : destinationPostalCode,
          destinationradius: destinationRadius,
          trailertype: TrailerType,
          favouritesearchindicator: favorite,
          searchdate: new Date().toISOString(),
          dropStartDate:
            getDropStartDateData(newdropStartDate, dropLocal),
          dropEndDate:
            getDropEndDateData(newdropEndDate, dropLocal),
          pickupEndDate:
            getPickUpEndDateData(pickUpEndDate, pickupLocal),
          pickupStartDate:
            getPickUpStartDateData(pickUpStartDate, pickupLocal),
          carrierid: props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId,
          userid: props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.email,
          id: criteriaId
        };
        const modelF = new Favorite();
        if (!favorite) {
          ToastMessage.open({
            message: i18n.t("FAVORITE_SEARCH_REMOVED"),
            showUndo: true,
            callback: () => {
              const data = {
                ...searchParams,
                favouritesearchindicator: !searchParams.favouritesearchindicator,
              };
              props.updateFavoriteLoads(
                modelF.updateFavoriteLoadCheckDuplicate(data),
                false
              );
            },
          });
          props.updateFavoriteLoads(
            modelF.updateFavoriteLoad(searchParams),
            false
          );
        } else {
          props.updateFavoriteLoads(
            modelF.updateFavoriteLoadCheckDuplicate(searchParams),
            false)
        }

      } else {
        logEvent("ue_search_request", { page: "Search Page" });
        logEvent(EVENT.UE_SEARCH_SEE_RESULTS, {
          screen: SCREEN.SEARCH_FILTER,
          tab: TAB.NEW,
        });
        const searchParams: Isearch = {
          origin: originCity,
          originCountry,
          originState,
          originPostalCode,
          originRadius,
          destination: destinationCity,
          destinationStates,
          destinationCountry,
          destinationPostalCode : state.isStatesShow ? "" : destinationPostalCode,
          destinationRadius,
          TrailerType,
          dropStartDate:
          getDropStartDateData(newdropStartDate, dropLocal),
          dropEndDate:
          getDropEndDateData(newdropEndDate, dropLocal),
          pickUpEndDate:
          getPickUpEndDateData(pickUpEndDate, pickupLocal),
          pickUpStartDate:
          getPickUpStartDateData(pickUpStartDate, pickupLocal)
        };
        await storeSearchParamVault(searchParams);
        const searchRequest = getSearchInputes(searchParams, props.userDetails);
        props.submitForm(searchRequest);
        props.history.push("/app/search/results", {
          params: searchParams,
          searchInput: searchParams,
          totalRecords: props.totalRecords,
          isRecent: false,
          newSearch: true
        });
      }
    }
  }
};

export const handleValueChange = (event: any, state: any) => {
  let newValue = {};
  const { name, value, backClicked, country, currentLocation, postalCode } = event.target;
  const { dropStartDate, dropEndDate, pickUpEndDate, pickUpStartDate, pickUpLocalTime } = getTimeDetails(state);
  switch (name) {
    case Constants.Origin:
      newValue = {
        ...newValue,
        originError:
          pickUpErrorCheck(value, backClicked),
        originCountry: country,
        originPostalCode: postalCode,
        rangeOriginDisable: value === Constants.Anywhere,
        dropUpdateError:
          dropStartDate !== "" && !state.rangeOriginDisable && value !== Constants.Anywhere &&
            (dropEndDate < pickUpEndDate || dropStartDate < pickUpStartDate) && state.destination !== Constants.Anywhere
            ? true
            : false,
        currentLocation: currentLocation || {}
      };
      break;
    case Constants.Destination:
      newValue = {
        ...newValue,
        rangeDisable:
          getRangeDisable(value),
        dropUpdateError:
          getDropUpdateError(value, state),
        destinationCountry: country,
        destinationPostalCode: postalCode,
        destinationError:
          getDestinationErrorDetails(value, backClicked),
      };
      if (value.length > 0 && value !== Constants.Anywhere) {
        newValue = {
          ...newValue,
          dropUpdateError:
            dropStartDate !== "" && !state.rangeOriginDisable &&
              (dropStartDate < pickUpStartDate ||
                dropEndDate < pickUpEndDate)
              ? true
              : false,
        };
      }
      break;
    case "pickUpStartDate":
      newValue = {
        ...newValue,
        pickUpdateError: value < pickUpLocalTime ? true : false,
        dropUpdateError: dateValidation(state)
      };
      break;
    case "pickUpEndDate":
      newValue = {
        ...newValue,
        dropUpdateError: dateValidation(state),
      };
      break;
    case "dropStartDate":
      newValue = {
        ...newValue,
        dropUpdateError: dateValidation(state)
      };
      break;
    case "dropEndDate":
      newValue = {
        ...newValue,
        dropUpdateError: dateValidation(state)
      };
      break;
  }
  return newValue;
};

const dateValidation = (state: any) => {
  const {
    pickUpStartDate,
    pickUpEndDate,
    dropStartDate,
    dropEndDate,
    rangeOriginDisable,
    rangeDisable
  } = state;
  return (pickUpStartDate > dropStartDate || pickUpEndDate > dropEndDate || dropStartDate > dropEndDate) && dropStartDate !== "" && !rangeDisable && !rangeOriginDisable;
}

export const getErrorValue = (value: boolean, name: string) => {
  let newValue = {};
  if (name === Constants.Origin && value === true) {
    newValue = { originError: Constants.PickupError };
  } else if (name === Constants.Destination && value === true) {
    newValue = { destinationError: Constants.DropoffError };
  } else if (name === Constants.Origin && value === false) {
    newValue = { originError: "" };
  } else if (name === Constants.Destination && value === false) {
    newValue = { destinationError: "" };
  }
  return newValue;
};

export const storeSearchParamVault = async (searchParam: any) => {
  IONICWrapper.details.vault &&
    (await IONICWrapper.details.vault.storeValue(
      'searchParam',
      JSON.stringify(searchParam)
    ));
}

const  getOrginAndDestinationCheck=(state: any, destinationStates: any[])=> {
  return (state.origin === Constants.Anywhere &&
    ((state.destination === Constants.Anywhere && !state.isStatesShow) ||
      (state.isStatesShow && destinationStates.length === 0))) ||
    (state.isStatesShow && destinationStates.length === 0);
}

const getOriginArray=(origin: any)=> {
  return origin.indexOf(",") !== -1 ? origin.split(",") : [origin, ""];
}

const  getDestinationArray = (destination: any) =>{
  return destination.indexOf(",") !== -1
    ? destination.split(",")
    : [destination, ""];
}
const getDestinationError = (state: any, isDestinationError: boolean) =>{
  if (state.isStatesShow) {
    isDestinationError = false;
  } else {
    isDestinationError = state.dropUpdateError || state.destinationError !== "" || state.isDropTimeError;
  }
  return isDestinationError;
}

const errorValidation = (state: any, isDestinationError: boolean) =>{
  return state.originError === "" &&
    !state.pickUpdateError &&
    !state.isCityError &&
    !state.isPickUpTimeError &&
    !isDestinationError;
}

const getPickUpStartDateData=(pickUpStartDate: any, pickupLocal: string) =>{
  return (pickUpStartDate &&
    `${pickUpStartDate.split("T")[0]}T${pickupLocal}`) ||
    "";
}

const getPickUpEndDateData=(pickUpEndDate: any, pickupLocal: string) =>{
  return (pickUpEndDate &&
    `${pickUpEndDate.split("T")[0]}T${pickupLocal}`) ||
    "";
}

const getDropEndDateData = (newdropEndDate: any, dropLocal: string)=> {
  return (newdropEndDate && `${newdropEndDate.split("T")[0]}T${dropLocal}`) ||
    "";
}

const getDropStartDateData = (newdropStartDate: any, dropLocal: string) =>{
  return (newdropStartDate &&
    `${newdropStartDate.split("T")[0]}T${dropLocal}`) ||
    "";
}

const getTimeDetails=(state: any)=> {
  const pickUpLocalTime = state.pickUpLocalTime && state.pickUpLocalTime.split("T")[0];
  const pickUpStartDate = state.pickUpStartDate && state.pickUpStartDate.split("T")[0] || '';
  const pickUpEndDate = state.pickUpEndDate && state.pickUpEndDate.split("T")[0] || '';
  const dropStartDate = state.dropStartDate && state.dropStartDate.split("T")[0] || '';
  const dropEndDate = state.dropEndDate && state.dropEndDate.split("T")[0] || '';
  return { dropStartDate, dropEndDate, pickUpEndDate, pickUpStartDate, pickUpLocalTime };
}

const pickUpErrorCheck =(value: any, backClicked: any) =>{
  return value.length === 0 && !backClicked ? Constants.PickupError : "";
}

const getDestinationErrorDetails=(value: any, backClicked: any) =>{
  return value.length === 0 && !backClicked ? Constants.DropoffError : "";
}

const getDropUpdateError=(value: any, state: any)=> {
  return value.length > 0 && value === Constants.Anywhere
    ? false
    : state.dropUpdateError;
}

const getRangeDisable =(value: any)=> {
  return value.length > 0 && value !== Constants.Anywhere ? false : true;
}

